import PageShell from "./PageShell";

export default function Privacy() {
  return (
    <PageShell testId="privacy-page" eyebrow="Legal" title="Privacy Policy" intro="How Agroya Refinery LLP collects, uses and protects your information." seo={{title:"Privacy Policy · Agroya Refinery LLP", description:"How Agroya Refinery LLP collects, uses and protects your data.", canonical:"https://agroya1935.com/privacy"}}>
      <p>This Privacy Policy describes how Agroya Refinery LLP ("we", "our", "us") collects, uses, and discloses information when you visit our website or engage our services.</p>
      <h3>Information We Collect</h3>
      <p>We collect contact details you voluntarily provide via forms (name, email, phone, company, message). We do not sell personal data.</p>
      <h3>How We Use Information</h3>
      <p>To respond to enquiries, provide quotes, send periodic updates (if subscribed), and improve our services.</p>
      <h3>Data Security</h3>
      <p>We use industry-standard measures to safeguard your data. Material in our physical custody is protected by bank-grade vault systems and continuous monitoring.</p>
      <h3>Your Rights</h3>
      <p>You may request access, correction or deletion of your data by contacting <a href="mailto:info@agroya1935.com">info@agroya1935.com</a>.</p>
    </PageShell>
  );
}
